import React from 'react';
import './login.css';
import { Link } from 'react-router-dom';
import Btn from '../components/btn';
import logo from '../assets/icons/logo.svg';

const Login = () => {
    return ( <>
        <main className='alignCenterLogin'>
            <div className="bgDecor"></div>
            <form className='login'>
                <img src={logo} alt="Cairo International Book Fair Logo" />
                <h2>Welcome Back</h2>
                <div className="loginField">
                    <label>Email Address</label>
                    <input type="email" />
                </div>
                <div className="loginField">
                    <label>Password</label>
                    <input type="password" />
                </div>
                <Link to="/Home">
                <Btn btnText="Sign In" btnStyle="mainBtn" btnType="submit" />
                </Link>
                <h5>Don't have an account?</h5>
                <Link to="/Home">
                <Btn btnText="Create Account" btnStyle="secondaryBtn" />
                </Link>
            </form>
        </main>
    </> );
}
 
export default Login;